// src/components/ui/GenericToggle.js
import React from 'react';
import * as Switch from '@radix-ui/react-switch';

/**
 * Generic Toggle Switch Component
 * A compact green/red toggle with a circular thumb containing an inner circle
 *
 * @param {boolean} checked - If true, shows "yes" state (green); if false, shows "no" state (gray/red)
 * @param {function} onCheckedChange - Callback when switch is toggled
 */
const GenericToggle = ({ checked, onCheckedChange }) => {
  return (
    <Switch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="relative flex-shrink-0 transition-colors duration-app-normal ease-out"
      style={{
        width: '28px',
        height: '16px',
        backgroundColor: checked ? '#10B981' : '#E1E5EA', // app-success : app-gray-300
        borderRadius: '8px', // pill shape
        border: '1px solid #0C141D', // app-gray-900
        boxShadow: '0 -2px 0 0 #0C141D', // drop shadow above, no blur
        position: 'relative',
        cursor: 'pointer',
      }}
    >
      {/* Slider thumb - circular with inner circle */}
      <Switch.Thumb
        className="flex items-center justify-center transition-transform duration-app-normal ease-out"
        style={{
          width: '16px',
          height: '16px',
          borderRadius: '50%', // circular
          border: '1px solid #303840', // app-gray-900
          boxShadow: '0 2px 0 0 #303840', // drop shadow below, no blur
          transform: checked ? 'translateX(11px) translateY(-3px)' : 'translateX(-1px) translateY(-3px)',
          backgroundColor: '#F2F5F7', // app-gray-200 (always gray)
          willChange: 'transform'
        }}
      >
        {/* Inner circle dot */}
        <div
          className="transition-colors duration-app-normal ease-out"
          style={{
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            backgroundColor: checked ? '#10B981' : '#F2F5F7', // app-success : app-gray-200
          }}
        />
      </Switch.Thumb>
    </Switch.Root>
  );
};

export default GenericToggle;
